import * as yup from "yup";
import mapValues from "lodash/mapValues";

export const localizationSchema = yup.lazy((obj) =>
  yup.object(mapValues(obj, () => yup.string().required())).required(),
);
